import { getAmplitudeInstance } from '../amplitudeHelpers';
import WebPageScrollDepth from '../enums/WebPageScrollDepth';

type logWebPageDepthScrolledParams = {
  href?: string;
  scroll_depth?: WebPageScrollDepth;
};

/**
 * Tracks how far down the web page a user scrolls. Should fire when the user hits 25%/50%/75%/100% of page. Should only fire once per depth reached per page viewed. Will not work for pages with infinite scroll (profile, community).
 * @param params - Attributes to log with the amplitude event
 * @param params.href - Url of page where user scrolled
 * @param params.scroll_depth - How far down the page the user scrolled (percentage of page)
 */
const logWebPageDepthScrolled = ({ href, scroll_depth }: logWebPageDepthScrolledParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('web page depth scrolled', { href, 'scroll depth': scroll_depth }, callback);
};

export default logWebPageDepthScrolled;
